var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"chip text-uppercase d-inline-flex align-items-center gap-2",class:_vm.chipData.classes,style:(_vm.chipData.styles)},[(_vm.chipData.icon)?_c('b-icon',{attrs:{"icon":_vm.chipData.icon}}):_vm._e(),_c('span',{staticClass:"font-size-70"},[_vm._v(_vm._s(_vm.chipData.label))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }